import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    title: 'Escaneo',
    description: 'Sigues la guía para identificar tus "Fugas" y "Fuegos" financieros en una sesión rápida de 10 minutos.'
  }, {
    title: 'Blindaje',
    description: 'Configuras las automatizaciones y alertas de "Cero Fricción" que el kit te indica.'
  }, {
    title: 'Recuperación',
    description: 'Usas los guiones de cancelación y el protocolo anti-impulso para mantener tu dinero en tu bolsillo mes tras mes.'
  }];
  return <section className="py-24 bg-brand-cream" data-id="element-85">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-86">
        <FadeIn data-id="element-87">
          <div className="text-center mb-16" data-id="element-88">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-teal mb-4" data-id="element-89">
              Cómo funciona
            </h2>
            <div className="w-16 h-[2px] bg-brand-gold mx-auto" data-id="element-90"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-91">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-[1px] bg-brand-gold/30 z-0" data-id="element-92"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-93">
              <div className="flex flex-col items-center text-center" data-id="element-94">
                <div className="w-24 h-24 rounded-full bg-white border-2 border-brand-gold flex items-center justify-center mb-6 shadow-sm" data-id="element-95">
                  <span className="text-4xl font-serif font-bold text-brand-teal" data-id="element-96">
                    {index + 1}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-brand-teal mb-4 font-serif" data-id="element-97">
                  {step.title}
                </h3>
                <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-98">
                  {step.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}